import Activities from './Activities/Activities.vue';
import ActivitiesGroups from './ActivitiesGroups/ActivitiesGroups.vue';
import ActivitiesGroupsCreateEdit from 'src/views/Pages/Dashboard/Work/ActivitiesGroups/ActivitiesGroupsCreateEdit.vue';
import ActivitiesReport from './ActivitiesReport/ActivitiesReport.vue';
import SmartTrackReport from 'src/views/Pages/Dashboard/Work/SmartTrack/Report.vue';
import ActivitiesSheets from './ActivitiesReport/ActivitiesSheets.vue';
import ActivityRates from './ActivityRates/ActivityRates.vue';
import ActivityUnits from './ActivityUnits/ActivityUnits.vue';
import ActivityValues from './ActivityValues/ActivityValues.vue';
import ActivityValuesCreateEdit from 'src/views/Pages/Dashboard/Work/ActivityValues/ActivityValuesCreateEdit.vue';
import Bonuses from './Bonuses/Bonuses.vue';
import CaptureCPA from './CPA/Capture.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import GeneralConfiguration from './GeneralConfiguration/GeneralConfiguration.vue';
import Jobs from './Jobs/Jobs.vue';
import LaborsCatchs from 'src/views/Pages/Dashboard/Work/Catch/Catchs.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import PaymentCalendar from 'src/views/Pages/Dashboard/PaymentCalendar/PaymentCalendars.vue';
import PaymentCalendarsCreateEdit from 'src/views/Pages/Dashboard/PaymentCalendar/CreateEdit.vue';
import Payroll from './ActivitiesReport/Payroll/Payroll.vue';
import ReportCPA from './CPA/Report.vue';
import SegregatedByOperators from './ActivitiesReport/SegregatedByOperators.vue';
import SpecialDayAssistance from './ActivitiesReport/SpecialDayAssistance.vue';
import TimeTypes from './TimeTypes/TimeTypes.vue';
import TypeAbsences from './TypeAbsences/TypeAbsences.vue';
import TypeAbsencesCreateEdit from 'src/views/Pages/Dashboard/Work/TypeAbsences/TypeAbsencesCreateEdit.vue';
import TypeContracts from './TypeContracts/TypeContracts.vue';
import WayuuCommunityBonus from './ActivitiesReport/WayuuCommunityBonus.vue';
import Workers from './Workers/Workers.vue';

const WorksRoutes = {
  path: 'works',
  name: 'labor.labours',
  component: MasterTab,
  props: { reference: 'worksTabs' },
  children: [
    {
      path: 'jobs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: Jobs,
          meta: {
            prefix_permission: 'works_jobs',
          },
        },
      ],
    },
    {
      path: 'workers',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: Workers,
          meta: {
            prefix_permission: 'works_workers',
          },
        },
      ],
    },
    {
      path: 'activityunits',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivityUnits,
          meta: {
            prefix_permission: 'works_activityunits',
          },
        },
      ],
    },
    {
      path: 'typecontracts',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: TypeContracts,
          meta: {
            prefix_permission: 'works_typecontracts',
          },
        },
      ],
    },
    {
      path: 'timetypes',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: TimeTypes,
          meta: {
            prefix_permission: 'works_timetypes',
          },
        },
      ],
    },
    {
      path: 'laborheader',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivitiesReport,
          meta: {
            prefix_permission: 'works_laborheader',
          },
        },
      ],
    },
    {
      path: 'activitysheets',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivitiesSheets,
          meta: {
            prefix_permission: 'works_activitysheets',
          },
        },
      ],
    },
    {
      path: 'segregatedbyoperators',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: SegregatedByOperators,
          meta: {
            prefix_permission: 'works_segregatedbyoperators',
          },
        },
      ],
    },
    {
      path: 'specialdayassistance',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: SpecialDayAssistance,
          meta: {
            prefix_permission: 'works_specialdayassistance',
          },
        },
      ],
    },
    {
      path: 'payroll',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: Payroll,
          meta: {
            prefix_permission: 'works_payroll',
          },
        },
      ],
    },
    {
      path: 'wayuucommunitybonus',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: WayuuCommunityBonus,
          meta: {
            prefix_permission: 'works_wayuucommunitybonus',
          },
        },
      ],
    },
    {
      path: 'activityrates',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivityRates,
          meta: {
            prefix_permission: 'works_activityrates',
          },
        },
      ],
    },
    {
      path: 'activityvalues',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivityValues,
          meta: {
            prefix_permission: 'works_activityvalues',
          },
        },
        {
          path: 'create',
          name: 'labor.labours',
          component: ActivityValuesCreateEdit,
          meta: {
            prefix_permission: 'works_activityvalues',
          },
        },
        {
          path: 'edit',
          name: 'labor.labours',
          component: ActivityValuesCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'works_activityvalues',
          },
        },
      ],
    },
    {
      path: 'activitiesgroups',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivitiesGroups,
          meta: {
            prefix_permission: 'works_activitiesgroups',
          },
        },
        {
          path: 'create',
          name: 'labor.labours',
          component: ActivitiesGroupsCreateEdit,
          meta: {
            prefix_permission: 'works_activitiesgroups',
          },
        },
        {
          path: 'edit',
          name: 'labor.labours',
          component: ActivitiesGroupsCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'works_activitiesgroups',
          },
        },
      ],
    },
    {
      path: 'activities',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.activities',
          component: Activities,
          meta: {
            prefix_permission: 'works_activities',
          },
        },
      ],
    },
    {
      path: 'bonuses',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.bonus',
          component: Bonuses,
          meta: {
            prefix_permission: 'works_bonuses',
          },
        },
      ],
    },
    {
      path: 'typeabsences',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: TypeAbsences,
          meta: {
            prefix_permission: 'works_typeabsences',
          },
        },
        {
          path: 'create',
          name: 'labor.labours',
          component: TypeAbsencesCreateEdit,
          meta: {
            prefix_permission: 'works_typeabsences',
          },
        },
        {
          path: 'edit',
          name: 'labor.labours',
          component: TypeAbsencesCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'works_typeabsences',
          },
        },
      ],
    },
    {
      path: 'catchs',
      name: 'production.capture_labors',
      component: LaborsCatchs,
      meta: {
        prefix_permission: 'works_catchs',
      },
    },
    {
      path: 'generalconfiguration',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.general_configuration',
          component: GeneralConfiguration,
          meta: {
            prefix_permission: 'works_generalconfiguration',
          },
        },
      ],
    },
    {
      path: 'cpa',
      name: 'labor.cpa',
      component: CaptureCPA,
      meta: {
        prefix_permission: 'works_cpa',
      },
    },
    {
      path: 'reportcpa',
      name: 'labor.labours',
      component: ReportCPA,
      meta: {
        prefix_permission: 'works_cpa',
      },
    },
    {
      path: 'paymentcalendars',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.payment_calendars',
          component: PaymentCalendar,
          meta: {
            prefix_permission: 'works_paymentcalendars',
          },
        },
        {
          path: 'create',
          name: 'common_words.payment_calendars',
          component: PaymentCalendarsCreateEdit,
          meta: {
            prefix_permission: 'works_paymentcalendars',
          },
        },
        {
          path: 'edit',
          name: 'common_words.payment_calendars',
          component: PaymentCalendarsCreateEdit,
          meta: {
            prefix_permission: 'works_paymentcalendars',
          },
        },
      ],
    },
    {
      path: 'smarttrack',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.smarttrack_report',
          component: SmartTrackReport,
          /* meta: {
            prefix_permission: 'works_smarttrack',
          }, */
        },
      ],
    },
  ],
};

export default WorksRoutes;
